export default "__VITE_ASSET__D9BGFrGG__"